import { combineReducers } from 'redux';

import settings from '../../common/reducers/settings';
import experiments from '../../common/reducers/experiments';
import roles from '../../common/reducers/roles';
import ffPage from '../../common/state/ff-page/reducer';
import members from '../../common/state/members/reducer';
import site from '../../common/state/site/reducer';
import badgesDefinitions from '../../common/reducers/badges-definitions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FFState = any;

export const reducer = combineReducers({
  settings,
  members,
  roles,
  experiments,
  site,
  ffPage,
  badgesDefinitions,
});
